(function(){
"use strict";

var SHOP = '/products/';
var UTM  = '';

var SITE = 'https://systellar.in';
var SUTM = '?utm_source=shopify&utm_medium=selector&utm_campaign=scc_selector';

var MODELS = [
  { id:'c100', name:'CC-MPPT-Compact-100', family:'MPPT', tag:'Entry 12V–24V',
    url:SITE+'/product/cc-mppt-compact/'+SUTM,
    img:'https://systellar.in/images/MPPT-Compact-with-LCD-display.webp',
    banks:[12,24], maxVoc:85, amps:[25,50], pvHeadline:{50:1600}, order:1,
    shop:SHOP+'systellar-mppt-solar-charge-controller-compact-100'+UTM,
    blurb:'Our entry MPPT for single 12 V and 24 V banks — full MPPT tracking, LCD display, lithium and lead-acid profiles.' },

  { id:'c200', name:'CC-MPPT-Compact-200', family:'MPPT', tag:'Entry 12V–48V',
    url:SITE+'/product/cc-mppt-compact/'+SUTM,
    img:'https://systellar.in/images/MPPT-Compact-with-LCD-display.webp',
    banks:[12,24,36,48], maxVoc:175, amps:[25,50], pvHeadline:{25:1500,50:3000}, order:2,
    shop:SHOP+'systellar-mppt-solar-charge-controller-compact-200'+UTM,
    blurb:'The same compact body with a 175 V input, so you can run longer series strings and reach a 48 V bank.' },

  { id:'gen6', name:'CC-MPPT-Gen6-200', family:'MPPT', tag:'Best seller',
    url:SITE+'/product/mppt-solar-charge-controller-gen-6/'+SUTM,
    img:'https://systellar.in/images/MPPT-Gen6-LCD-display.webp',
    banks:[12,24,36,48], maxVoc:175, amps:[50,75], pvHeadline:{50:3400,75:4860}, order:3,
    shop:SHOP+'systellar-mppt-solar-charge-controller-gen6'+UTM,
    blurb:'Our highest-current 12–48 V controller, with a graphic LCD, RS485/Modbus option and a built-in power saver. The model most of our installers standardise on.' },

  { id:'hv300', name:'CC-MPPT-HV-300', family:'MPPT', tag:'High voltage',
    url:SITE+'/product/cc-mppt-hv-300/'+SUTM,
    img:'https://systellar.in/images/CC-MPPT-HV-300-high-voltage-MPPT-solar-charge-controller-front-view-with-LCD-display.webp',
    banks:[48,60,72,96,120], maxVoc:265, minVoc:106, amps:[60], pvHeadline:{60:9600}, order:4,

    coldMargin:1.06,
    shop:SHOP+'cc-mppt-hv-300'+UTM,
    blurb:'Built for high-voltage banks from 48 V to 120 V — factories, institutions, petrol pumps and telecom sites.' },
];

var CHEM = {
  lfp:{ vpb:14.6, dod:0.80, eff:0.97, label:'LiFePO4' },
  nmc:{ vpb:12.6, dod:0.80, eff:0.97, label:'Li-ion' },
  tub:{ vpb:14.4, dod:0.50, eff:0.85, label:'tubular lead-acid' },
  smf:{ vpb:14.4, dod:0.50, eff:0.85, label:'SMF lead-acid' },
  gel:{ vpb:14.4, dod:0.50, eff:0.85, label:'gel lead-acid' }
};

var MPPT_EFF   = 0.97;
var PWM_HARV   = 0.72;
var DERATE     = 0.80;
var COLD_MARGIN= 1.10;

function coldMargin(m){ return m && m.coldMargin ? m.coldMargin : COLD_MARGIN; }
var PSH        = 4.5;
var OVERSIZE   = 1.25;

var $ = function(id){ return document.getElementById(id); };
var el = {
  bank:$('syBank'), chem:$('syChem'), ah:$('syAh'), wp:$('syWp'), qty:$('syQty'),
  voc:$('syVoc'), vocC:$('syVocCustom'), vocCW:$('syVocCustomWrap'), series:$('sySeries'),
  psize:$('syPanelSize'), orient:$('syOrient'), rows:$('syRows')
};

var built = false;
var animateNext = false;

var STEPS = [
  { id:'bank',  label:'battery bank voltage', ok:function(){ return !!el.bank.value; } },
  { id:'chem',  label:'battery type',         ok:function(){ return !!el.chem.value; } },
  { id:'ah',    label:'battery capacity',     ok:function(){ return num0(el.ah); } },
  { id:'array', label:'panel size and count', ok:function(){ return num0(el.wp) && num0(el.qty); } },
  { id:'voc',   label:'panel Voc',            ok:function(){ return el.voc.value && (el.voc.value !== 'custom' || num0(el.vocC)); } }
];
function num0(input){ var v = parseFloat(input.value); return isFinite(v) && v > 0; }

function readiness(){
  var done = 0, next = null;
  STEPS.forEach(function(st){ if(st.ok()) done++; else if(!next) next = st; });
  return { done:done, total:STEPS.length, next:next };
}

function syncSeriesOptions(){
  var q = parseFloat(el.qty.value);
  var have = (isFinite(q) && q > 0) ? Math.floor(q) : 0;
  var opts = el.series.options, resetNeeded = false, offered = 0;

  for(var i = 0; i < opts.length; i++){
    if(opts[i].value === 'auto') continue;
    var n = parseInt(opts[i].value, 10);
    var tooMany = have > 0 && n > have;
    opts[i].disabled = tooMany;
    opts[i].hidden   = tooMany;
    if(!tooMany) offered++;
    if(tooMany && el.series.value === opts[i].value) resetNeeded = true;
  }

  if(resetNeeded) el.series.value = 'auto';

  $('sySeriesHint').innerHTML = have > 0
    ? 'Leave on automatic and we will suggest the safest wiring for each controller. You have entered <b>' +
      have + ' panel' + (have > 1 ? 's' : '') + '</b>, so at most ' + have + ' can go in one series string.'
    : 'Leave on automatic and we will suggest the safest wiring for each controller.';
}

function progress(){
  syncSeriesOptions();
  var r = readiness();
  var pct = Math.round(r.done / r.total * 100);
  $('syProgTxt').textContent = r.done + ' of ' + r.total;
  $('syProgBar').style.width = pct + '%';
  var b = $('syBuild');
  if(r.done < r.total){
    b.disabled = true;
    b.removeAttribute('data-state');
    $('syBuildLbl').textContent = 'Add your ' + r.next.label;
    $('syBuildNote').textContent = (r.total - r.done) + ' more to go — or pick a starting point above.';
  } else {
    b.disabled = false;
    b.setAttribute('data-state', built ? 'done' : 'ready');
    $('syBuildLbl').textContent = built ? 'Rebuild my system' : 'Build my system';
    $('syBuildNote').textContent = built
      ? 'Change any detail above and the results update as you type.'
      : 'Ready. We will energise the diagram and size the whole system.';
  }
  return r;
}

function num(input, fallback){
  var v = parseFloat(input.value);
  return (isFinite(v) && v > 0) ? v : fallback;
}
function fmt(n, d){ d = d||0; return n.toLocaleString('en-IN',{minimumFractionDigits:d, maximumFractionDigits:d}); }
function hrs(h){
  if(!isFinite(h) || h<=0) return '—';
  if(h < 1) return Math.round(h*60) + ' min';
  return fmt(h,1) + ' h';
}
function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

function bestSeries(panelVoc, qty, ceiling){
  var maxS = Math.floor(ceiling / (panelVoc * COLD_MARGIN));
  if(maxS < 1) return 0;

  for(var s = Math.min(maxS, qty); s >= 1; s--){
    if(qty % s === 0) return s;
  }
  return 1;
}

function compute(){
  var bank    = parseFloat(el.bank.value);
  var chemKey = el.chem.value;
  var chem    = CHEM[chemKey];
  var ah      = num(el.ah, 100);
  var wp      = num(el.wp, 100);
  var qty     = Math.max(1, Math.round(num(el.qty, 1)));
  var panelVoc= el.voc.value === 'custom' ? num(el.vocC, 45) : parseFloat(el.voc.value);

  var blocks  = bank / 12;
  var vCharge = chem.vpb * blocks;
  var arrayW  = wp * qty;

  return {
    bank:bank, chemKey:chemKey, chem:chem, ah:ah, wp:wp, qty:qty,
    panelVoc:panelVoc, vCharge:vCharge, arrayW:arrayW,

    whNeeded: (ah * bank * chem.dod) / chem.eff
  };
}

function evaluate(m, amps, s){
  var r = { model:m, amps:amps, ok:true, why:[], reason:'', clip:false };

  if(m.banks.indexOf(s.bank) === -1){
    r.ok = false;
    var range = m.banks.length === 1
      ? m.banks[0] + ' V only'
      : m.banks[0] + '–' + m.banks[m.banks.length-1] + ' V only';
    r.code = 'BANK';
    r.reason = 'Does not support a ' + s.bank + ' V bank (' + range + ').';
    return r;
  }

  var isMPPT = m.family === 'MPPT';
  var minStringVoc = (isMPPT ? 1.45 : 1.15) * s.vCharge;
  if(m.minVoc) minStringVoc = Math.max(minStringVoc, m.minVoc);
  var maxStringVoc = m.maxVoc / coldMargin(m);
  if(!isMPPT) maxStringVoc = Math.min(maxStringVoc, 2.0 * s.vCharge);

  var minS = Math.ceil(minStringVoc / s.panelVoc - 1e-9);
  var maxS = Math.floor(maxStringVoc / s.panelVoc + 1e-9);

  var forced = el.series.value === 'auto' ? null : parseInt(el.series.value,10);
  var series, uneven = false;

  if(forced){
    series = forced;

    if(series > s.qty){
      r.ok = false;
      r.code = 'SERIES_GT_QTY';
      r.reason = 'You have entered ' + s.qty + ' panel' + (s.qty>1?'s':'') + ' in total, so ' + series +
                 ' in series is not possible.';
      return r;
    }
    if(series < minS){
      r.ok = false;
      r.code = 'VOC_LOW'; r.minS = minS;
      r.reason = series + ' × ' + fmt(s.panelVoc,0) + ' V = ' + fmt(series*s.panelVoc,0) + ' V, too low to charge a ' +
        s.bank + ' V bank once the panels are hot. It needs at least ' + minS + ' in series.';
      return r;
    }
    if(series > maxS){
      r.ok = false;
      r.code = 'VOC_HIGH'; r.maxS = maxS;
      r.reason = series + ' in series reaches ' + fmt(series*s.panelVoc*coldMargin(m),0) +
        ' V on a cold morning, over its ' + m.maxVoc + ' V input limit. Maximum here is ' + maxS + ' in series.';
      return r;
    }
  } else {
    if(minS > maxS){
      r.ok = false;
      r.code = 'WINDOW';
      r.reason = 'No whole number of ' + fmt(s.panelVoc,0) + ' V panels fits its input window for a ' + s.bank +
        ' V bank (needs ' + fmt(minStringVoc,0) + '–' + fmt(maxStringVoc,0) + ' V per string). A panel with a different Voc would fit.';
      return r;
    }
    if(minS > s.qty){
      r.ok = false;
      r.code = 'SERIES_LOW'; r.minS = minS;
      r.reason = 'Needs at least ' + minS + ' panel' + (minS>1?'s':'') + ' in series to charge a ' + s.bank + ' V bank; you have ' + s.qty + '.';
      return r;
    }

    var hi = Math.min(maxS, s.qty), chosen = 0;
    for(var S = hi; S >= minS; S--){ if(s.qty % S === 0){ chosen = S; break; } }
    if(!chosen){ chosen = hi; uneven = true; }
    series = chosen;
  }

  r.series    = series;
  r.strings   = Math.ceil(s.qty / series);
  r.stringVoc = series * s.panelVoc * coldMargin(m);
  r.minS      = minS;
  r.maxS      = maxS;
  r.uneven    = uneven;
  r.remainder = s.qty % series;

  var harvest = m.family === 'MPPT' ? MPPT_EFF : PWM_HARV;
  r.iPotential = (s.arrayW * harvest) / s.vCharge;
  r.iActual    = Math.min(amps, r.iPotential);
  r.util       = r.iActual / amps;

  if(r.iPotential > amps * OVERSIZE){
    r.clip = true;
    r.clipPct = Math.round((1 - amps / r.iPotential) * 100);
    if(r.clipPct > 60){
      r.ok = false;
      r.code = 'CLIP';
      r.reason = 'Would throw away ' + r.clipPct + '% of your array — it can only pass ' + amps +
                 ' A of the ' + fmt(r.iPotential,0) + ' A these panels can make at this bank voltage.';
      return r;
    }
  }

  if(m.pvHeadline && m.pvHeadline[amps] && s.arrayW > m.pvHeadline[amps] * 1.02){
    r.overHeadline = m.pvHeadline[amps];
  }

  if(r.iPotential < amps * 0.10){
    r.ok = false;
    r.code = 'UNDERSIZED';
    r.reason = 'Far too large for this array. It would run at ' + Math.round(r.util*100) + '% of its rating — a smaller model does the same job.';
    return r;
  }

  var pIn   = Math.min(s.arrayW * DERATE * harvest, amps * s.vCharge);
  r.hours   = s.whNeeded / pIn;
  r.days    = r.hours / PSH;
  r.watts   = r.iActual * s.vCharge;

  var score = 100;
  score -= Math.abs(0.85 - r.util) * 45;
  if(r.clip)          score -= r.clipPct * 0.95;
  if(r.overHeadline)  score -= 14;
  if(m.family==='PWM')score -= 20;

  if(m.shop)          score += 8;
  score -= (m.order * 0.35);
  r.score = score;
  return r;
}

function setNum(id, value, dp, unit){
  var host = $(id);
  var n = host.querySelector('.n');
  if(!n){ host.innerHTML = '<span class="n">0</span><span class="u">' + unit + '</span>'; n = host.querySelector('.n'); }
  else { host.querySelector('.u').textContent = unit; }
  if(animateNext) countUp(n, value, dp); else n.textContent = fmt(value, dp);
}
function setDash(id, unit){
  $(id).innerHTML = '<span class="n">—</span><span class="u">' + (unit||'') + '</span>';
}

function render(){
  var r = progress();
  if(r.done < r.total || !built) return;

  var s = compute();

  var fits = [], out = [];
  MODELS.forEach(function(m){
    var best = null, bestRej = null;
    m.amps.forEach(function(a){
      var r = evaluate(m, a, s);
      if(r.ok){ if(!best || r.score > best.score) best = r; }
      else if(!bestRej) bestRej = r;
    });
    if(best) fits.push(best);
    else out.push({ model:m, reason:(bestRej && bestRej.reason) || 'Not suitable for this system.',
                    code:bestRej && bestRej.code, minS:bestRej && bestRej.minS,
                    maxS:bestRej && bestRej.maxS });
  });
  fits.sort(function(a,b){ return b.score - a.score; });

  var pick = fits[0] || null;

  setNum('syVArray', s.arrayW, 0, 'Wp');
  $('sySArray').textContent = s.qty + ' panel' + (s.qty>1?'s':'') + ' × ' + fmt(s.wp) + ' Wp';

  var kCur = $('syKCur'), kTime = $('syKTime'), kVoc = $('syKVoc');
  kCur.className = 'sysel-kpi'; kTime.className = 'sysel-kpi'; kVoc.className = 'sysel-kpi';

  if(pick){
    setNum('syVCur', pick.iActual, 1, 'A');
    $('sySCur').textContent = pick.clip
      ? 'capped by the controller — array can make ' + fmt(pick.iPotential,1) + ' A'
      : 'peak, full sun · ' + fmt(pick.watts,0) + ' W into the battery';
    if(pick.clip) kCur.className = 'sysel-kpi is-warn';

    if(pick.hours < 1) setNum('syVTime', pick.hours*60, 0, 'min');
    else               setNum('syVTime', pick.hours, 1, 'h');
    $('sySTime').textContent = 'from ' + Math.round((1-s.chem.dod)*100) + '% to full · about ' +
      (pick.days < 1.05 ? 'one day' : fmt(pick.days,1) + ' days') + ' of sun';

    setNum('syVVoc', pick.stringVoc, 0, 'V');
    $('sySVoc').textContent = pick.series + ' in series × ' + pick.strings + ' string' + (pick.strings>1?'s':'') +
      ' · within the ' + pick.model.maxVoc + ' V limit';
  } else {
    setDash('syVCur','');  $('sySCur').textContent = 'no standard model matches yet';
    setDash('syVTime',''); $('sySTime').textContent = 'adjust the inputs, or talk to us';
    setNum('syVVoc', s.panelVoc * COLD_MARGIN, 0, 'V');
    $('sySVoc').textContent = 'per panel, cold-morning'; kVoc.className = 'sysel-kpi is-bad';
  }

  var notes = [];
  if(!pick){
    notes.push(['bad','!','<b>No off-the-shelf model matches this combination.</b> That is not a dead end — we build to specification. Send us these figures and we will tell you what is possible.']);
  } else {

    if(pick.stringVoc > pick.model.maxVoc * 0.96){
      notes.push(['warn','!','<b>This string sits right on the controller’s input limit</b> — ' +
        fmt(pick.stringVoc,0) + ' V of ' + pick.model.maxVoc + ' V on a cold morning. That is fine for the panel Voc you entered, ' +
        'but check the Voc printed on your actual module before you wire it: panels sold as “' + fmt(s.panelVoc,0) + ' V” ' +
        'are often specified a volt or two higher, and on this string that is enough to go over. If yours reads higher, ' +
        'use one fewer panel in series and add a parallel string instead.']);
    }
    if(pick.clip){
      notes.push(['warn','!','<b>Your array is larger than this controller can pass.</b> It will still work and it will not be damaged — the controller simply limits output, so you lose roughly ' + pick.clipPct + '% of peak-sun energy. That is a normal, deliberate design choice on a cloudy-climate site; if you want all of it, step up a model or split the array across two controllers.']);
    }
    if(pick.overHeadline){
      notes.push(['warn','!','Your ' + fmt(s.arrayW) + ' Wp array is above the ' + fmt(pick.overHeadline) + ' Wp we publish for this model at its top bank voltage. Worth a quick confirmation from us before you order.']);
    }
    if(pick.util < 0.45){
      notes.push(['warn','i','This controller will run at only ' + Math.round(pick.util*100) + '% of its rating. That is safe and leaves room to add panels later — but if the array is not going to grow, a smaller model is the cheaper answer.']);
    }
    if(pick.model.family === 'PWM'){
      notes.push(['warn','i','<b>PWM harvests less than MPPT from the same panels</b> — typically 15–30% less, because it cannot convert surplus panel voltage into extra charging current. It is chosen for cost, not for yield.']);
    }
    if(s.chemKey === 'nmc'){
      notes.push(['warn','i','Li-ion / NMC banks charge at a <i>lower</i> voltage per 12 V block than LiFePO4 (12.6 V against 14.6 V), so the same array produces more amps but less power. Confirm your pack’s exact charge voltage with its BMS supplier.']);
    }
    if(s.chem.dod === 0.50){
      notes.push(['ok','✓','Lead-acid figures assume you use half the bank before recharging. Going deeper than that repeatedly is the usual reason a lead-acid bank dies early.']);
    }
    var freeV = pick.model.maxVoc - pick.stringVoc;
    if(freeV > pick.stringVoc * 0.45 && pick.series < s.qty){
      notes.push(['ok','✓','You have headroom on the input: this string reaches ' + fmt(pick.stringVoc,0) + ' V of a ' + pick.model.maxVoc + ' V limit. Longer series strings mean thinner cable and lower losses on a long run from the array.']);
    }
  }
  $('syNotes').innerHTML = notes.map(function(n){
    return '<div class="sysel-note ' + n[0] + '"><span class="ic">' + n[1] + '</span><div>' + n[2] + '</div></div>';
  }).join('');

  var pickHtml = '';
  if(pick){
    var m = pick.model;
    var why = 'For a ' + s.bank + ' V ' + s.chem.label + ' bank with ' + fmt(s.arrayW) + ' Wp of panels, this is the closest fit in the range — ' +
      (pick.clip
        ? 'it runs at its full ' + pick.amps + ' A rating and caps a slightly oversized array.'
        : 'it delivers ' + fmt(pick.iActual,1) + ' A of the ' + pick.amps + ' A it is rated for, leaving sensible headroom.');
    pickHtml =
      '<div class="sysel-pick">' +
        '<div class="sysel-pick-top"><span class="dot"></span>Best fit for your system</div>' +
        '<div class="sysel-pick-in">' +
          '<div class="sysel-shot"><img src="' + esc(m.img) + '" alt="' + esc(m.name) + '" loading="lazy"></div>' +
          '<div>' +
            '<span class="fam">' + m.family + ' · ' + esc(m.tag) + '</span>' +
            '<h4>' + esc(m.name) + ' · ' + pick.amps + ' A</h4>' +
            '<p class="why">' + esc(m.blurb) + '</p>' +
            '<p class="why">' + why + '</p>' +
            '<div class="sysel-specs">' +
              '<span class="sysel-spec">Charging <b>' + fmt(pick.iActual,1) + ' A</b> @ ' + fmt(s.vCharge,1) + ' V</span>' +
              '<span class="sysel-spec">Wiring <b>' + pick.series + ' in series × ' + pick.strings + '</b></span>' +
              '<span class="sysel-spec">String Voc <b>' + fmt(pick.stringVoc,0) + ' V</b> of ' + m.maxVoc + ' V</span>' +
              '<span class="sysel-spec">Full charge in <b>' + hrs(pick.hours) + '</b> of sun</span>' +
            '</div>' +

            '<div class="sysel-actions">' +
              '<a class="sysel-btn g" href="' + esc(m.url) + '">See full specification <span aria-hidden="true">→</span></a>' +
              (m.shop
                ? '<a class="sysel-btn p" href="' + esc(m.shop) + '" target="_blank" rel="noopener">Buy the ' + esc(m.name) + ' online <span aria-hidden="true">→</span></a>'
                : '<a class="sysel-btn p" href="' + SITE + '/contact-us/' + SUTM + '">Request a quote — built to order <span aria-hidden="true">→</span></a>') +
            '</div>' +
            (m.shop ? '' : '<p class="why" style="margin-top:9px;font-size:0.78rem;">This model is built to order rather than stocked online. Tell us your requirement and we will quote it, usually the same day.</p>') +
          '</div>' +
        '</div>' +
      '</div>';
  } else {

    var diag = blockedReason(out, s);
    pickHtml =
      '<div class="sysel-pick"><div class="sysel-pick-top"><span class="dot"></span>' + esc(diag.head) + '</div>' +
      '<div class="sysel-pick-in" style="grid-template-columns:1fr">' +
        '<div><h4>' + esc(diag.title) + '</h4>' +
        '<p class="why">' + diag.body + '</p>' +
        '<p class="why">We are the manufacturer, not a reseller, so if none of the standard models suits you, a ' +
        'non-standard voltage, current or enclosure is a conversation rather than a refusal.</p>' +
        '<div class="sysel-actions"><a class="sysel-btn p" href="' + SITE + '/contact-us/' + SUTM + '">Send these specs to an engineer <span aria-hidden="true">→</span></a>' +
        '<a class="sysel-btn g" href="tel:+919568004455">Call +91 95680 04455</a></div></div>' +
      '</div></div>';
  }
  $('syPick').innerHTML = pickHtml;
  $('syMatchCount').textContent = fits.length + ' of ' + MODELS.length + ' models fit this system';

  var alts = fits.slice(1);
  if(alts.length){
    $('syAltWrap').style.display = '';
    $('syAlts').innerHTML = alts.map(function(r){
      var t = r.clip ? 'Caps at ' + r.amps + ' A' : (r.util < 0.45 ? 'Room to grow' : 'Good fit');
      return '<div class="sysel-alt' + (r.clip?' is-clip':'') + '">' +
        '<span class="t">' + t + '</span>' +
        '<span class="n"><a href="' + esc(r.model.url) + '">' + esc(r.model.name) + ' · ' + r.amps + ' A</a></span>' +
        '<span class="d">' + r.model.family + ' · ' + fmt(r.iActual,1) + ' A charging · ' + r.series + ' panel' + (r.series>1?'s':'') + ' in series · full in ' + hrs(r.hours) + '</span>' +
        '<span class="d" style="margin-top:2px">' +
          '<a href="' + esc(r.model.url) + '" style="color:var(--green);font-weight:600;text-decoration:none">Specification</a>' +
          ' &nbsp;·&nbsp; ' +
          (r.model.shop
            ? '<a href="' + esc(r.model.shop) + '" target="_blank" rel="noopener" style="color:var(--amber-deep);font-weight:600;text-decoration:none">Buy online →</a>'
            : '<a href="' + SITE + '/contact-us/' + SUTM + '" style="color:var(--amber-deep);font-weight:600;text-decoration:none">Get a quote →</a>') +
        '</span>' +
        '</div>';
    }).join('');
  } else {
    $('syAltWrap').style.display = 'none';
  }

  $('syOutLbl').textContent = out.length + ' model' + (out.length===1?'':'s') + ' ruled out, and why';
  $('syOut').innerHTML = out.map(function(o){
    return '<div class="sysel-outrow"><span class="m">' + esc(o.model.name) + '</span><span class="r">' + esc(o.reason) + '</span></div>';
  }).join('') || '<div class="sysel-outrow"><span class="r">Every model in the range can run this system.</span></div>';

  var q = 'Bank ' + s.bank + 'V ' + s.chem.label + ' ' + fmt(s.ah) + 'Ah, array ' + s.qty + '×' + fmt(s.wp) + 'Wp (' + fmt(s.arrayW) + 'Wp), panel Voc ' + fmt(s.panelVoc,1) + 'V';
  $('syEnq').setAttribute('href', SITE + '/contact-us/' + SUTM + '&system=' + encodeURIComponent(q));

  suggest(s, pick, fits);
  layout(s, pick);
  scoreCard(s, pick);
  paint(s, pick);
  animateNext = false;
}

var VOC_CHOICES = [55, 50, 41, 38, 21.6];

function stringFix(s){
  var outs = [];
  MODELS.forEach(function(m){
    if(m.banks.indexOf(s.bank) === -1) return;
    var minV = Math.max(1.45 * s.vCharge, m.minVoc || 0);
    var maxV = m.maxVoc / coldMargin(m);
    var opts = [];
    VOC_CHOICES.forEach(function(v){
      var lo = Math.ceil(minV / v), hi = Math.floor(maxV / v);
      if(lo <= hi) opts.push({ voc:v, series:lo });
    });
    if(opts.length) outs.push({ model:m, opts:opts });
  });
  return outs;
}

function stringFixLine(s){
  var f = stringFix(s);
  if(!f.length) return '';

  var best = f[0];
  var o = best.opts.slice(0, 2).map(function(x){
    return '<b>' + fmt(x.voc,1).replace('.0','') + ' V panels, ' + x.series + ' in series</b>';
  }).join(' — or ');
  return '<br><br><b>The controller is not the problem here, the panel choice is.</b> ' +
         'For a ' + s.bank + ' V bank the <b>' + esc(best.model.name) + '</b> is the right model; ' +
         'it simply needs a string inside its input window — ' + o + ' would run it. ' +
         (best.model.shop
            ? 'Once your panels are settled you can buy it here: <a href="' + esc(best.model.shop) + '">' + esc(best.model.name) + '</a>.'
            : '');
}

function blockedReason(out, s){
  var byCode = {};
  out.forEach(function(o){ if(o.code && !byCode[o.code]) byCode[o.code] = o; });
  var minPanels = 0;
  out.forEach(function(o){ if(o.code === 'SERIES_LOW' && o.minS) minPanels = minPanels ? Math.min(minPanels, o.minS) : o.minS; });

  if(byCode.SERIES_GT_QTY){
    return {
      head:'More in series than you have panels',
      title:'You cannot wire more panels in series than you own',
      body:'You have entered <b>' + s.qty + ' panel' + (s.qty>1?'s':'') + '</b> but asked for a longer series string ' +
           'than that. Set <i>Panels per series string</i> back to automatic and we will work out the safest wiring for you.'
    };
  }

  if(byCode.VOC_HIGH){
    var bestMax = 0;
    out.forEach(function(o){ if(o.code === 'VOC_HIGH' && o.maxS) bestMax = Math.max(bestMax, o.maxS); });
    return {
      head:'Too many panels in series',
      title:'That series string is above every controller’s input limit',
      body:'You have set <b>' + esc(el.series.value) + ' in series</b>, which reaches about <b>' +
           fmt(parseInt(el.series.value,10) * s.panelVoc * COLD_MARGIN, 0) + ' V</b> on a cold morning — above the ' +
           'input limit of every model that supports a ' + s.bank + ' V bank. ' +
           (bestMax ? 'The most you can put in one string here is <b>' + bestMax + '</b>. ' : '') +
           'Set <i>Panels per series string</i> back to automatic and we will work out the safest wiring.'
    };
  }
  if(byCode.VOC_LOW){
    var needS = 0;
    out.forEach(function(o){ if(o.code === 'VOC_LOW' && o.minS) needS = needS ? Math.min(needS, o.minS) : o.minS; });
    return {
      head:'Too few panels in series',
      title:'That series string is too low to charge a ' + s.bank + ' V bank',
      body:'You have set <b>' + esc(el.series.value) + ' in series</b>, which makes about <b>' +
           fmt(parseInt(el.series.value,10) * s.panelVoc, 0) + ' V</b> — below the ' + fmt(s.vCharge,1) +
           ' V this bank charges at once the panels are hot. ' +
           (needS ? 'You would need at least <b>' + needS + ' in series</b>. ' : '') +
           'Set <i>Panels per series string</i> back to automatic and we will work it out for you.'
    };
  }
  if(byCode.SERIES_LOW){
    return {
      head:'Not enough panels in series',
      title:'You need more panels in series for a ' + s.bank + ' V bank',
      body:'A ' + s.bank + ' V bank charges at about <b>' + fmt(s.vCharge,1) + ' V</b>, and a panel string has to stay above that ' +
           'even when the panels are hot at midday. Your ' + fmt(s.panelVoc,0) + ' V panels would need at least <b>' + minPanels +
           ' wired in series</b>, but you have entered ' + s.qty + ' panel' + (s.qty>1?'s':'') + ' in total. ' +
           'Add panels, or use a lower bank voltage.' + stringFixLine(s)
    };
  }
  if(byCode.WINDOW){
    return {
      head:'Right controller, wrong panel string',
      title:'These panels do not string up for a ' + s.bank + ' V bank',
      body:'Each string has to stay above about <b>' + fmt(1.45*s.vCharge,0) + ' V</b> when hot and below the controller’s ' +
           'input limit on a cold morning, and no whole number of ' + fmt(s.panelVoc,0) + ' V panels lands inside that window. ' +
           'A panel with a different Voc almost always solves it — tell us what you can source and we will work back from that.' + stringFixLine(s)
    };
  }
  if(byCode.CLIP){
    return {
      head:'Array too large for one controller',
      title:'This array is bigger than any single controller at ' + s.bank + ' V',
      body:'At ' + s.bank + ' V your ' + fmt(s.arrayW) + ' Wp would try to push roughly <b>' +
           fmt((s.arrayW*0.97)/s.vCharge,0) + ' A</b> into the battery. The usual answers are a higher bank voltage ' +
           '(which cuts the current proportionally), or splitting the array across two controllers — which also gives ' +
           'you redundancy on a site that cannot afford to stop.'
    };
  }
  if(byCode.UNDERSIZED){
    return {
      head:'Array too small to be worth a controller',
      title:'This array is very small for a ' + s.bank + ' V bank',
      body:'Your ' + fmt(s.arrayW) + ' Wp would deliver well under a tenth of what our smallest ' + s.bank +
           ' V controller is built to pass. Either the array needs to be larger, or the bank voltage lower. ' +
           'Check the panel wattage and count you entered.'
    };
  }
  return {
    head:'Outside the standard range',
    title:'No standard model covers a ' + s.bank + ' V bank',
    body:'Our off-the-shelf range does not cover this bank voltage with the panels you described. ' +
         'That is exactly the kind of job we take on as a custom build.'
  };
}

function suggest(s, pick, fits){
  var out = [];
  var key = function(t){ return {t:t, key:true}; };
  var say = function(t){ return {t:t, key:false}; };

  if(!pick){
    out.push(key('<b>Nothing in the standard range fits this exactly — so talk to us.</b> We are the manufacturer. A non-standard bank voltage, current rating or enclosure is a design job, not a refusal, and we have done it many times for telecom, railway and institutional sites.'));
    out.push(say('Before you call, check the two figures most often mis-entered: the <b>bank</b> voltage (not the panel voltage), and <b>Voc</b> from the panel label (not Vmp, which is lower).'));
  } else {
    var m = pick.model;
    var cRate = pick.iActual / s.ah;
    var lith  = s.chem.dod === 0.80;

    out.push(key('<b>Go with the ' + esc(m.name) + ' at ' + pick.amps + ' A.</b> On a ' + s.bank + ' V ' +
      esc(s.chem.label) + ' bank with ' + fmt(s.arrayW) + ' Wp of panels it delivers about <b>' + fmt(pick.iActual,1) +
      ' A</b> into the battery, and wires as <b>' + pick.series + ' panel' + (pick.series>1?'s':'') + ' in series × ' + pick.strings + ' string' +
      (pick.strings>1?'s':'') + '</b>. ' +
      (m.shop ? 'It is in stock and can be bought online today.' : 'It is built to order — send us the specification and we will quote it.')));

    if(cRate < 0.05){
      out.push(key('<b>Your array is small for this battery.</b> It charges at roughly C/' + Math.round(1/cRate) +
        ', so a full recharge takes about ' + fmt(pick.days,1) + ' days of good sun — the bank will rarely see 100%. ' +
        'Either add panels, or use a smaller battery bank. As a rule we would want at least C/10 here.'));
    } else if(!lith && cRate > 0.20){
      out.push(key('<b>That is a fast charge for lead-acid.</b> At C/' + (1/cRate).toFixed(1) +
        ' the bank will gas and run hot, and it will not last as long as it should. Either add battery capacity, ' +
        'or accept that the controller will spend much of the day limiting. Lithium would take this rate comfortably.'));
    } else if(lith && cRate > 0.55){
      out.push(say('This charges at about C/' + (1/cRate).toFixed(1) + '. LiFePO4 tolerates that, but confirm your ' +
        'BMS is rated for ' + fmt(pick.iActual,0) + ' A of charge current before you commit.'));
    } else {
      out.push(say('The charge rate works out at about <b>C/' + (1/cRate).toFixed(1) + '</b>, which is a healthy ' +
        'figure for ' + esc(s.chem.label) + ' — fast enough to finish inside a day, gentle enough not to shorten the bank’s life.'));
    }

    if(pick.clip && pick.clipPct > 25 && s.bank < 48){
      var nextBank = s.bank === 12 ? 24 : 48;
      out.push(key('<b>The real fix here is the battery bank, not the controller.</b> Charging current is array watts ' +
        'divided by bank voltage, so moving from ' + s.bank + ' V to ' + nextBank + ' V would halve the current this ' +
        'array makes and bring it inside a single controller — with thinner cable and lower losses as a bonus. ' +
        'Worth deciding before you buy the batteries.'));
    }

    if(pick.uneven){
      var good = [];
      for(var q = Math.max(pick.series, s.qty - 3); q <= s.qty + 3; q++){ if(q % pick.series === 0) good.push(q); }
      var short = pick.series - pick.remainder;
      out.push(key('<b>Your ' + s.qty + ' panels do not divide into equal strings of ' + pick.series + '.</b> ' +
        'One string would be short by ' + short + ' panel' + (short>1?'s':'') + ', and a short string makes a lower ' +
        'voltage that drags the whole array down. ' +
        (good.length ? 'Going to <b>' + good.join(' or ') + ' panels</b> divides evenly. ' : '') +
        'Otherwise feed the odd string through its own controller input.'));
    }

    if(pick.clip){
      var bigger = fits.filter(function(f){ return !f.clip; })[0];
      out.push(key('<b>Your array is bigger than this controller can pass</b>, so you lose about ' + pick.clipPct +
        '% of peak-sun energy. That is safe and quite common — but if you want all of it, ' +
        (bigger ? 'step up to the <b>' + esc(bigger.model.name) + ' at ' + bigger.amps + ' A</b>, ' : '') +
        'or split the array across two controllers, which also gives you redundancy on a critical site.'));
    } else if(pick.util < 0.45){
      out.push(say('This controller runs at only ' + Math.round(pick.util*100) + '% of its rating. That is money ' +
        'spent on headroom — worth it if you plan to add panels later, wasteful if you do not. Tell us which, and we will confirm the size.'));
    }

    var headroom = m.maxVoc - pick.stringVoc;
    if(pick.series === 1 && s.qty > 1){
      out.push(say('All ' + s.qty + ' panels are in parallel here, which means thick cable and a combiner box. ' +
        'If your panels allow a higher series count, longer strings cut the current, the cable cost and the losses on a long run.'));
    } else if(headroom > pick.stringVoc * 0.5){
      out.push(say('You have used only ' + fmt(pick.stringVoc,0) + ' V of a ' + m.maxVoc + ' V input, so there is room ' +
        'to add panels to each string later without rewiring — worth planning for now while the roof is empty.'));
    }

    if(m.family === 'PWM'){
      out.push(say('<b>Consider MPPT before you commit.</b> PWM is cheaper up front, but on this array it harvests ' +
        'roughly 15–30% less every day for the life of the system. On anything above a few hundred watts the MPPT usually pays for itself inside two seasons.'));
    }
    if(!lith){
      out.push(say('A <b>battery temperature sensor</b> is worth adding on lead-acid. Charging voltage has to fall as ' +
        'the battery warms; without the sensor the controller is guessing, and in an Indian summer that guess costs you battery life.'));
    }
    if(m.id === 'gen6' || m.id === 'hv300' || m.id === 'hv50'){
      out.push(say('This model has the <b>power saver built in</b>, so you do not need the separate SMU. If you want ' +
        'remote monitoring, the RS485/Modbus card is a plug-in option — no special firmware needed.'));
    } else if(m.family === 'MPPT'){
      out.push(say('If you want to log or monitor this remotely, all Compact models support the <b>RS485/Modbus card</b>, sold separately.'));
    }
  }

  $('sySugg').innerHTML = out.slice(0,5).map(function(o){

    return '<li' + (o.key ? ' class="is-key"' : '') + '><span>' + o.t + '</span></li>';
  }).join('');
}

function scoreCard(s, pick){
  var v = 0, title, sub, chips = [];
  if(!pick){
    v = 0;
    title = 'Custom build territory';
    sub = 'Nothing off the shelf matches — which is exactly the kind of job we take on.';
    chips.push(['warnc','Bespoke design']);
  } else {
    var m = pick.model;
    v = 62;
    if(!pick.clip)                       { v += 12; chips.push(['','No energy clipped']); }
    else                                 { chips.push(['warnc', pick.clipPct + '% clipped at peak']); }
    if(pick.util >= 0.6 && pick.util<=1) { v += 12; chips.push(['','Right-sized, ' + Math.round(pick.util*100) + '% used']); }
    if(m.family === 'MPPT')              { v += 9;  chips.push(['','MPPT — 15–30% more yield']); }
    else                                 { chips.push(['warnc','PWM — lower yield']); }
    if(pick.stringVoc <= m.maxVoc * 0.85){ v += 5;  chips.push(['','Voc margin for cold mornings']); }
    if(pick.days <= 1.05)                { chips.push(['','Full charge in one day of sun']); }
    if(!pick.overHeadline)               { v += 2; }
    if(m.shop)                           { chips.push(['','In stock — buy online']); }
    v = Math.max(35, Math.min(99, Math.round(v)));

    title = v >= 90 ? 'Excellent match' : v >= 78 ? 'Strong match' : v >= 62 ? 'Workable match' : 'Compromised match';
    sub   = v >= 90 ? 'This is close to the ideal pairing for the system you described.'
          : v >= 78 ? 'A sound choice, with one or two things worth confirming below.'
          : v >= 62 ? 'It will run, but the points below are worth reading before you buy.'
          :           'It will work, but the system is unbalanced — the suggestions below explain how.';
  }

  var C = 2 * Math.PI * 45;
  var arc = $('syArc');
  arc.setAttribute('stroke-dashoffset', (C * (1 - v/100)).toFixed(1));
  arc.setAttribute('stroke', v >= 78 ? '#0F6E56' : v >= 62 ? '#EF9F27' : '#A62F2A');
  countUp($('syScoreNum'), v, 0);
  $('syScoreTitle').textContent = title;
  $('syScoreSub').textContent = sub;
  $('syChips').innerHTML = chips.map(function(c,i){
    return '<span class="sysel-chip ' + c[0] + '" style="animation-delay:' + (i*80) + 'ms">✓ ' + esc(c[1]) + '</span>';
  }).join('');
}

function countUp(node, to, dp){
  var from = parseFloat(String(node.textContent).replace(/[^0-9.]/g,'')) || 0;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if(reduced || document.hidden){ node.textContent = fmt(to, dp); return; }

  var t0 = null, dur = 850, done = false;
  function land(){ if(!done){ done = true; node.textContent = fmt(to, dp); } }
  function step(ts){
    if(done) return;
    if(t0 === null) t0 = ts;
    var p = Math.min(1, (ts - t0) / dur);
    var e = 1 - Math.pow(1 - p, 3);
    node.textContent = fmt(from + (to - from) * e, dp);
    if(p < 1) requestAnimationFrame(step); else land();
  }
  requestAnimationFrame(step);
  setTimeout(land, dur + 150);
}

function layout(s, pick){
  var svg = $('syLayout');
  var series = pick ? pick.series : (el.series.value === 'auto' ? 1 : parseInt(el.series.value,10));
  var qty = s.qty;

  var pw, ph;
  if(el.psize.value === 'auto'){
    var area = s.wp / 200;
    pw = Math.sqrt(area / 1.86);
    ph = pw * 1.86;
  } else {
    var parts = el.psize.value.split('x');
    ph = parseFloat(parts[0]); pw = parseFloat(parts[1]);
  }
  if(el.orient.value === 'l'){ var t = pw; pw = ph; ph = t; }

  var GAPX = 0.02, GAPY = 0.60;

  var rows;
  if(el.rows.value === 'compact'){
    var bestErr = Infinity;
    for(var rr = 1; rr <= qty; rr++){
      var per = Math.ceil(qty / rr);
      var wIt = per * pw + (per - 1) * GAPX;
      var hIt = rr * ph + (rr - 1) * GAPY;
      var err = Math.abs((wIt / hIt) - 1.7);
      if(err < bestErr){ bestErr = err; rows = rr; }
    }
  } else if(el.rows.value === 'string'){
    rows = Math.max(1, Math.ceil(qty / series));
  } else {
    rows = Math.min(parseInt(el.rows.value,10), qty);
  }
  var perRow = Math.ceil(qty / rows);
  var totalW = perRow * pw + (perRow - 1) * GAPX;
  var totalH = rows * ph + (rows - 1) * GAPY;
  var panelArea = qty * pw * ph;

  var PAD = 52;
  var scale = Math.min(700 / totalW, 360 / totalH, 96);
  var drawW = totalW * scale, drawH = totalH * scale;
  var VW = Math.max(520, Math.min(820, drawW + 300));
  var ox = (VW - drawW) / 2, oy = 78;
  var VH = drawH + oy + 66;
  svg.setAttribute('viewBox', '0 0 ' + VW.toFixed(0) + ' ' + VH.toFixed(0));

  var nStrings = Math.ceil(qty / series);
  var STRINGC = ['#0F6E56','#EF9F27','#1B5E8A','#8E44AD','#C0392B','#16A085'];
  var g = '<title>Plan view of the suggested solar panel arrangement and string wiring</title>';

  g += '<rect x="' + (ox-14) + '" y="' + (oy-14) + '" width="' + (drawW+28) + '" height="' + (drawH+28) +
       '" rx="9" fill="none" stroke="rgba(14,26,23,0.18)" stroke-width="1.4" stroke-dasharray="6 5"/>';

  var i = 0;
  for(var r = 0; r < rows; r++){
    var n = Math.min(perRow, qty - r*perRow);
    for(var c = 0; c < n; c++, i++){
      var x = ox + c * (pw + GAPX) * scale;
      var y = oy + r * (ph + GAPY) * scale;
      var w = pw * scale, h = ph * scale;
      var str = Math.floor(i / series);
      var col = STRINGC[str % STRINGC.length];
      g += '<g class="sysel-panel" style="animation-delay:' + (i*45) + 'ms">' +
           '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) +
           '" rx="3" fill="#153E5C" stroke="' + col + '" stroke-width="2.2"/>';

      for(var k=1;k<3;k++){
        g += '<line x1="' + x.toFixed(1) + '" y1="' + (y + h*k/3).toFixed(1) + '" x2="' + (x+w).toFixed(1) +
             '" y2="' + (y + h*k/3).toFixed(1) + '" stroke="rgba(255,255,255,0.18)" stroke-width="1"/>';
      }

      if(w >= 22 && h >= 20){
        g += '<text x="' + (x + w/2).toFixed(1) + '" y="' + (y + h/2 + 4).toFixed(1) +
             '" text-anchor="middle" fill="rgba(255,255,255,0.85)" font-size="10.5" font-family="Inter,sans-serif">' + (i+1) + '</text>';
      }
      g += '</g>';
    }
  }

  g += '<line x1="' + ox + '" y1="' + (oy + drawH + 30) + '" x2="' + (ox+drawW) + '" y2="' + (oy + drawH + 30) +
       '" stroke="#586863" stroke-width="1"/>' +
       '<text x="' + (ox + drawW/2) + '" y="' + (oy + drawH + 47) + '" text-anchor="middle" fill="#586863" font-size="12" font-family="Inter,sans-serif">' +
       totalW.toFixed(2) + ' m wide</text>';
  g += '<text x="' + (ox - 22) + '" y="' + (oy + drawH/2) + '" text-anchor="middle" fill="#586863" font-size="12" ' +
       'font-family="Inter,sans-serif" transform="rotate(-90 ' + (ox-22) + ' ' + (oy + drawH/2) + ')">' + totalH.toFixed(2) + ' m deep</text>';

  g += '<text x="' + PAD + '" y="26" fill="#0E1A17" font-size="13" font-weight="600" font-family="Sora,sans-serif">' +
       nStrings + ' string' + (nStrings>1?'s':'') + ' of ' + series + ' panel' + (series>1?'s':'') + ' in series</text>';
  var perLine = Math.max(1, Math.floor((VW - PAD*2) / 78));
  for(var sIdx=0; sIdx < Math.min(nStrings, 8); sIdx++){
    var lx = PAD + (sIdx % perLine) * 78;
    var ly = 48 + Math.floor(sIdx / perLine) * 16;
    g += '<rect x="' + lx + '" y="' + (ly-8) + '" width="13" height="4" rx="2" fill="' + STRINGC[sIdx % STRINGC.length] + '"/>' +
         '<text x="' + (lx + 18) + '" y="' + ly + '" fill="#586863" font-size="11" font-family="Inter,sans-serif">String ' + (sIdx+1) + '</text>';
  }
  svg.innerHTML = g;

  var uneven = (qty % series) !== 0 && series > 1;
  $('syCfgStats').innerHTML =
    stat('Footprint', totalW.toFixed(2) + ' × ' + totalH.toFixed(2) + ' m') +
    stat('Panel area', panelArea.toFixed(1) + ' m²') +
    stat('Wiring', series + 'S × ' + nStrings + 'P') +
    stat('Per panel', pw.toFixed(2) + ' × ' + ph.toFixed(2) + ' m');

  var note = 'Footprint includes a ' + GAPY.toFixed(2) + ' m walkway between rows and assumes panels are mounted flat in plan. ' +
    'On a tilted frame the ground shadow is shorter than the panel, but you must still leave inter-row space so one row never shades the next — ' +
    'as a rule of thumb, allow twice the frame height between rows for an Indian latitude.';
  if(uneven){
    note = '<b style="color:var(--warn)">Uneven strings.</b> ' + qty + ' panels do not divide into strings of ' + series +
      ', so one string will be shorter than the others. Strings of unequal length make different voltages and the shorter one is dragged down — ' +
      'either change the panel count to a multiple of ' + series + ', or feed the odd string through its own controller input. ' + note;
  }
  $('syCfgNote').innerHTML = note;
}
function stat(k,v){ return '<div class="sysel-cfg-stat"><span class="k">' + k + '</span><span class="v">' + v + '</span></div>'; }

function paint(s, pick){

  var cells = $('syCells'), g = '';
  var shown = Math.min(s.qty, 6);
  for(var i=1;i<shown;i++){
    var t = i/shown;
    var x1 = 0   + t*148, y1 = 96 - t*76;
    var x2 = 76  + t*148, y2 = 96 - t*76;
    g += '<line x1="'+x1.toFixed(1)+'" y1="'+y1.toFixed(1)+'" x2="'+x2.toFixed(1)+'" y2="'+y2.toFixed(1)+'"/>';
  }
  cells.innerHTML = g;

  $('syArrayLbl').textContent  = s.qty + ' × ' + fmt(s.wp) + ' Wp' + (s.qty > 6 ? ' (6 shown)' : '');
  $('syArrayLbl2').textContent = fmt(s.arrayW) + ' Wp array';

  $('syBattLbl').textContent = fmt(s.ah) + ' Ah · ' + s.bank + ' V ' + s.chem.label;

  if(pick){
    $('syLcdA').textContent   = fmt(pick.iActual,1) + 'A';
    $('syLcdW').textContent   = fmt(pick.watts,0) + ' W · ' + pick.model.family;
    $('syBoxModel').textContent = pick.model.name.replace('CC-MPPT-','').replace('CC-PWM-','PWM-').replace('CC-','');
    $('syWire1Lbl').textContent = fmt(pick.stringVoc,0) + ' V string · ' + pick.series + 'S' + pick.strings + 'P';
    $('syWire2Lbl').textContent = fmt(pick.iActual,1) + ' A @ ' + fmt(s.vCharge,1) + ' V';
    $('syBattEta').textContent  = 'Full in ≈ ' + hrs(pick.hours) + ' of good sun';

    var speed = Math.max(0.32, Math.min(2.6, 26 / Math.max(pick.iActual, 1)));
    $('syFlow1').style.setProperty('--flow', speed.toFixed(2) + 's');
    $('syFlow2').style.setProperty('--flow', speed.toFixed(2) + 's');
    $('syFlow1').style.opacity = 1; $('syFlow2').style.opacity = 1;

    var start = 1 - s.chem.dod;
    $('syBattWrap').style.setProperty('--soc', start.toFixed(2));
    $('syBattFill').setAttribute('fill', pick.clip ? '#B8730B' : '#0F6E56');
    $('syBattPct').textContent = Math.round(start*100) + '% → 100%';
  } else {
    $('syLcdA').textContent = '--.-A';
    $('syLcdW').textContent = 'no match';
    $('syBoxModel').textContent = 'NO MATCH';
    $('syWire1Lbl').textContent = fmt(s.panelVoc * COLD_MARGIN,0) + ' V per panel';
    $('syWire2Lbl').textContent = '—';
    $('syBattEta').textContent  = 'Talk to an engineer';
    $('syFlow1').style.opacity = 0.18; $('syFlow2').style.opacity = 0.18;
    $('syBattFill').setAttribute('fill', '#A62F2A');
  }
}

var PRESETS = {
  home:{ bank:'24',  chem:'lfp', ah:200,  wp:450, qty:4,  voc:'50' },
  shop:{ bank:'48',  chem:'tub', ah:300,  wp:540, qty:8,  voc:'50' },

  ind: { bank:'120', chem:'tub', ah:600,  wp:380, qty:24, voc:'38' },

  sml: { bank:'12',  chem:'lfp', ah:100,  wp:380, qty:2,  voc:'38' }
};
function applyPreset(k){
  var p = PRESETS[k]; if(!p) return;
  el.bank.value = p.bank; el.chem.value = p.chem;
  el.ah.value = p.ah; el.wp.value = p.wp; el.qty.value = p.qty;
  el.voc.value = p.voc; el.vocCW.style.display = 'none';
  el.series.value = 'auto';
  progress();
  if(built) render();
}

var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function buildSystem(){
  if(readiness().done < STEPS.length) return;
  var firstTime = !built;
  built = true;
  animateNext = true;

  $('syStage').classList.remove('is-dormant');
  var res = $('syResults');

  var delay = (firstTime && !REDUCED) ? 1250 : 0;
  setTimeout(function(){
    res.hidden = false;
    render();
    if(!REDUCED){
      Array.prototype.forEach.call(res.children, function(c, i){
        c.classList.remove('sysel-reveal');
        void c.offsetWidth;
        c.style.animationDelay = (i * 110) + 'ms';
        c.classList.add('sysel-reveal');
      });
    }
    progress();
    if(firstTime){
      try { res.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block:'start' }); } catch(e){}
    }
  }, delay);
}

['bank','chem','ah','wp','qty','voc','vocC','series','psize','orient','rows'].forEach(function(k){
  var handler = function(){
    if(k === 'voc'){ el.vocCW.style.display = el.voc.value === 'custom' ? '' : 'none'; }
    progress();
    if(built) render();
  };
  el[k].addEventListener('input', handler);
  el[k].addEventListener('change', handler);
});

Array.prototype.forEach.call(document.querySelectorAll('.sysel-preset'), function(b){
  b.addEventListener('click', function(){ applyPreset(b.getAttribute('data-preset')); });
});
$('syReset').addEventListener('click', function(){
  ['bank','chem','voc'].forEach(function(k){ el[k].value = ''; });
  ['ah','wp','qty'].forEach(function(k){ el[k].value = ''; });
  el.series.value = 'auto'; el.vocCW.style.display = 'none';
  built = false; $('syResults').hidden = true;
  $('syStage').classList.add('is-dormant');
  progress();
});
$('syBuild').addEventListener('click', buildSystem);

progress();
})();
